import { render, staticRenderFns } from "./widget-treeSelect.vue?vue&type=template&id=83d12c1e&scoped=true"
import script from "./widget-treeSelect.vue?vue&type=script&lang=js"
export * from "./widget-treeSelect.vue?vue&type=script&lang=js"
import style0 from "./widget-treeSelect.vue?vue&type=style&index=0&id=83d12c1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d12c1e",
  null
  
)

export default component.exports